import {
  Button,
  DocumentList,
  DocumentListItemSkeleton,
  EmptyState,
  Grid,
  ListPanel,
  MenuItem,
  SearchField,
  SelectField,
} from '@all-manager/design-system-v2';
import FullPageLayout from '../../../../layout/FullPageLayout/FullPageLayout';
import NoDocumentsIcon from '../../assets/no-documents.svg?react';
import DocumentRow from '../../components/DocumentRow/DocumentRow';
import DocumentsPagination from '../../components/DocumentsPagination/DocumentsPagination';
import useDocumentsListPage, { ALL_TYPES, SORT_OPTIONS } from './useDocumentsListPage';

const SKELETON_ROWS = [0, 1, 2, 3, 4];

export default function DocumentsListPage() {
  const hook = useDocumentsListPage();

  return (
    <FullPageLayout htmlTitle="Documents" title="Documents">
      {hook.isLibraryEmpty ? (
        <EmptyState
          title="Aucun document"
          subtitle="Les documents ajoutés aux sujets, aux prestataires et aux réunions apparaîtront ici."
          image={<NoDocumentsIcon />}
        />
      ) : (
        <ListPanel
          toolbar={(
            <Grid container spacing={1}>
              <Grid size={{ xs: 12, md: 6 }}>
                <SearchField
                  value={hook.search}
                  onChange={hook.handleSearchChange}
                  label="Rechercher un document"
                  placeholder="Rechercher par nom"
                />
              </Grid>
              <Grid size={{ xs: 6, md: 3 }}>
                <SelectField<string>
                  label="Nature"
                  size="small"
                  fullWidth
                  value={hook.typeFilter}
                  onChange={hook.handleTypeChange}
                >
                  <MenuItem value={ALL_TYPES}>Toutes</MenuItem>
                  {hook.documentTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                  ))}
                </SelectField>
              </Grid>
              <Grid size={{ xs: 6, md: 3 }}>
                <SelectField<string>
                  label="Trier par"
                  size="small"
                  fullWidth
                  value={hook.sortValue}
                  onChange={hook.handleSortChange}
                >
                  {SORT_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                  ))}
                </SelectField>
              </Grid>
            </Grid>
          )}
          footer={hook.showPagination ? (
            <DocumentsPagination
              count={hook.count}
              page={hook.page}
              rowsPerPage={hook.rowsPerPage}
              onPageChange={hook.handlePageChange}
              onRowsPerPageChange={hook.handleRowsPerPageChange}
            />
          ) : undefined}
        >
          {hook.isError ? (
            <EmptyState
              title="Documents indisponibles"
              subtitle="Le chargement a échoué. Rechargez la page pour réessayer."
            />
          ) : hook.isLoading ? (
            <DocumentList aria-label="Documents" aria-busy>
              {SKELETON_ROWS.map((row) => <DocumentListItemSkeleton key={row} />)}
            </DocumentList>
          ) : hook.hasNoResult ? (
            <EmptyState
              title="Aucun résultat"
              subtitle={hook.noResultSubtitle}
              action={(
                <Button variant="text" size="small" onClick={hook.handleResetFilters}>
                  Effacer les filtres
                </Button>
              )}
            />
          ) : (
            <DocumentList aria-label="Documents">
              {hook.documents.map((doc) => <DocumentRow key={doc.id} document={doc} />)}
            </DocumentList>
          )}
        </ListPanel>
      )}
    </FullPageLayout>
  );
}
